/**
 * Call initiation, isolated so a Quo deep link is a one-file change later
 * (SPEC §13.1). V1 uses `tel:`, with copy-to-clipboard as the fallback for
 * desktop where `tel:` may not resolve.
 */
export { formatPhone, telHref } from '../../shared/phone';

export async function copyNumber(phoneNumber: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(phoneNumber);
    return true;
  } catch {
    // Denied permission, or an insecure context. The number is still on screen.
    return false;
  }
}
